import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
/*
Base UI includes { ng-zorro } as the base ui library
- Check https://ng.ant.design/docs/introduce/en for getting started with components
- Check /app/sandbox for UI samples 
*/
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NgxChartsModule } from '@swimlane/ngx-charts'; /* ngx-charts */


/* RICH TEXT EDITOR -- DEMO -- CHANGE AS DESIRED (Quill)*/
import { AngularEditorModule } from '@kolkov/angular-editor';
import { InboxRoutingModule } from './inbox-routing.module'
import { WorkbenchComponent } from './workbench/workbench.component';

import { SharedComponentsModule } from '../../shared-components'
import { SharedServicesModule } from '../../shared-services'

//Should be added for Translations to be loaded on Lazy Loads
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiLingualService } from 'app/BaseFramework/core/services'
import { CustomPipesModule } from 'app/BaseFramework/shared/custom-pipes/custom-pipes.module';
import { ClaimDashboardComponent } from './claim-dashboard/claim-dashboard.component';
import { NgZorroAntdModule } from 'app/ng-zorro.module';
import { WorkflowConfigurator } from 'app/ViewModules/shared-components/workflow-configurator/workflow-configurator.component';
//import { TaskListFilter } from 'app/BaseFramework/shared/custom-pipes/taskListFilter';
import { NgFlowchartModule } from '@joelwenzel/ng-flowchart';
import { StatusStepComponent } from 'app/ViewModules/shared-components/status-step/status-step.component';
import { ActionStepComponent } from 'app/ViewModules/shared-components/action-step/action-step.component';
import { SearchConfigurationComponent } from 'app/ViewModules/shared-components/search-configuration/search-configuration.component';
import { DataEntryStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/data-entry-step/data-entry-step.component';
import { AutoAdjudicationStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/auto-adjudication-step/auto-adjudication-step.component';
import { AutoUnderwritingStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/auto-underwriting-step/auto-underwriting-step.component';
import { PayoutStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/payout-step/payout-step.component';
import { InvestigationStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/investigation-step/investigation-step.component';
import { PolicyIssuenceStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/policy-issuence-step/policy-issuence-step.component';
import { PolicyRejectComponent } from 'app/ViewModules/shared-components/workflow-configurator/policy-reject-step/policy-reject-step.component';
import { ManualAdjudicationStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/manual-adjudication-step/manual-adjudication-step.component';
import { ManualUnderwritingStepComponent } from 'app/ViewModules/shared-components/workflow-configurator/manual-underwriting-step/manual-underwriting-step.component';

const _components = [WorkbenchComponent, ClaimDashboardComponent, WorkflowConfigurator, 
  StatusStepComponent, ActionStepComponent, SearchConfigurationComponent, 
  DataEntryStepComponent, AutoAdjudicationStepComponent, AutoUnderwritingStepComponent, PayoutStepComponent,
  InvestigationStepComponent, PolicyIssuenceStepComponent, PolicyRejectComponent,
  ManualAdjudicationStepComponent, ManualUnderwritingStepComponent]


@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    AngularEditorModule,
    NgZorroAntdModule,
    NzIconModule,
    InboxRoutingModule,
    SharedComponentsModule,
    SharedServicesModule,
    CustomPipesModule,
    NgxChartsModule,
    NgFlowchartModule
  ],
  declarations: [..._components],
  exports: [..._components]
})
export class InboxModule {
  //Should be added for Translations to be loaded on Lazy Loads
  constructor(private translateService: TranslateService,
    private multiLingualService: MultiLingualService) {
    this.multiLingualService.resetLanguageLocales(this.translateService)
  }
}
